//gp
export const tinyMCEApiKey = 'rk3ntw79uux2vx6q4kp5b52qsbse3206q8pij11up8vwbhfu';
//andrea
//export const tinyMCEApiKey = 'twj4dzqrnrkzil9tsdzupufw4jtt5t34ujzta4wvwsh4tacc';
